import { z } from 'zod';

export const createExamSchema = (
  examEventCourses: {
    id: string;
    examCourse: {
      code: string;
    };
  }[],
) => {
  const shape = examEventCourses.reduce(
    (acc, course) => {
      acc[course.id] = z
        .string({
          required_error: `กรุณาเลือก QSet ID number สำหรับ ${course.examCourse.code}`,
        })
        .min(1, `กรุณาเลือก QSet ID number สำหรับ  ${course.examCourse.code}.`)
        .optional();

      return acc;
    },
    {} as Record<string, z.ZodOptional<z.ZodString>>,
  );

  return z.object(shape);
};

export type EditQSetIdNumberFormSchemaType = z.infer<ReturnType<typeof createExamSchema>>;
